import { Driver, DriveStep } from "driver.js";
import { defaultTourConfig } from "..";
import { profileDetailGuideSteps } from "./profile-detail-guide";
import { personalInfoGuideSteps } from "./personal-info-guide";
import { paymentGuideSteps } from "./payment-info-guide";
import { rewardsLandingGuideSteps } from "@/pages/brand/onboarding/page-guides/rewards-landing-guide";

function getCurrentPageSteps(setCurrentPageLabel: (label: string) => void) {
  const pathname = window.location.pathname;
  const searchParams = new URLSearchParams(window.location.search);
  const tab = searchParams.get("tab");

  switch (pathname) {
    case "/affiliate/rewards":
      setCurrentPageLabel("Explanation of the reward types and their calculations");
      return rewardsLandingGuideSteps;
    case "/affiliate/settings":
      if (tab === "personal") {
        setCurrentPageLabel("A walkthrough on how to fill your personal information");
        return personalInfoGuideSteps;
      }
      if (tab === "profile") {
        setCurrentPageLabel("A walkthrough on how to setup your profile information");
        return profileDetailGuideSteps;
      }
      if(tab==="payment"){
        setCurrentPageLabel("A walkthrough on how to setup your payment information");
        return paymentGuideSteps;
      }
      return [];
    default:
      setCurrentPageLabel("About this page");
      return [];
  }
}

const onHighlight = (driverObj: Driver) => (_: any, step: any) => {
  if (step.element === "#SPF-save-button" || step.element === "#SDF-save-button" || step.element === "#SPF-save-button") {
    setTimeout(() => {
      driverObj.destroy();
    }, 2000);
  }
};

const startCurrentPageTour = (tourDriver: Driver, setCurrentPageLabel: (label: string) => void) => {
  const steps: DriveStep[] = getCurrentPageSteps(setCurrentPageLabel);

  tourDriver.setConfig(defaultTourConfig);
  // Here we set the unique steps for the current page tour
  tourDriver.setSteps(
    steps.map((step) => ({
      ...step,
      popover: {
        ...step.popover,
      },
      onHighlightStarted: onHighlight(tourDriver),
    }))
  );
  tourDriver.drive();
};

export default startCurrentPageTour;
